import { gql } from '@apollo/client';

export const ADMIN_SET_FACEBOOK_CONNECTIONS_ACCESS = gql`
  mutation AdminSetFacebookConnectionsAccess($userId: ID!, $enabled: Boolean!) {
    adminSetFacebookConnectionsAccess(userId: $userId, enabled: $enabled)
  }
`;
